import React from 'react';
import styled from 'styled-components';
import { Checkbox, media } from '@payright/web-components';
import { SCBlueCheckbox } from './checkbox-sc-blue';

interface MarketingCheckboxProps {
  /** Icon for the alert */
  icon?: React.ReactElement;
  marketingOptInText: string;
  selected: boolean;
  handleClick?: Function;
}

const SCMarketingCheckbox = styled(SCBlueCheckbox)`
  ${media.min.medium} {
    .multiline {
      height: 2em;
      align-items: center;
      column-gap: 2rem;

      span.checkmark {
        margin-top: 5px;
      }

      label {
        margin: 0px;
      }
    }
  }
`;

export type EventHandlerProps = {
  onClick: (e: React.MouseEvent) => void;
};

const MarketingCheckbox = ({
  icon,
  marketingOptInText,
  selected,
  handleClick,
}: MarketingCheckboxProps) => {
  return (
    <SCMarketingCheckbox>
      <div className="check-wrapper">
        <Checkbox
          icon={icon}
          value="Agree"
          className="marketingOptIn"
          handleClick={handleClick}
          checked={selected}
          name="marketingOptIn"
          multiline={true}
        >
          {marketingOptInText && <div className="blue-text">{marketingOptInText}</div>}
        </Checkbox>
      </div>
    </SCMarketingCheckbox>
  );
};

export default MarketingCheckbox;
